import React from "react";
import "./Services.css";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import HeroSection from "../../components/HeroSection/HeroSection";
import section_image_6 from "../../assets/images/section_image_6.jpg";
import { Helmet } from "react-helmet";

export default function Services() {
  return (
    <div className="service_page">
      <Helmet>
        <title>Services | Elegro Energy Limited</title>
        <link rel="canonical" href="/services" />
        <meta name="robots" content="index, follow" />
        <meta
          name="description"
          content="We are specialised in - supply only & full EPC turnkey, construction of electrical transmission, distribution network systems to power utilities, contractors and construction companies in Africa."
        />
      </Helmet>
      <HeroSection
        heroTitle="Our Services"
        heroParagraph="A highly successful and experienced trading and construction company."
        btnLink="/projects"
        btnText="View Projects"
        heroImage={section_image_6}
      />
      <ServiceSection />
    </div>
  );
}
